import styled from '@emotion/styled'

import { Colors, colors } from '../constants/colors'

export const StyledIcon = styled('div')<{
  rotate?: boolean
  isFocused?: boolean
  color?: Colors
  activeColor?: Colors
  focusColor?: Colors
  disabled?: boolean
}>`
  cursor: pointer;
  color: ${({ color = 'light2' }) => colors[color]};

  ${({ isFocused, focusColor = 'blue' }) =>
    isFocused &&
    `
      color: ${colors[focusColor]};
      outline: none;
  `}

  &:hover {
    color: ${({ activeColor = 'darkBlue1' }) => colors[activeColor]};
  }

  &:focus:not(:disabled) {
    outline: none;
  }

  &:focus-visible:not(:disabled) {
    color: ${({ focusColor = 'blue' }) => colors[focusColor]};
    outline: none;
  }
`

export const CaretIcon = styled(StyledIcon, {
  shouldForwardProp: (prop) => prop !== 'rotate' && prop !== 'as',
})`
  transform: ${({ rotate }) => rotate && 'rotate(180deg)'};
  transition: transform 200ms;
  color: ${({ rotate, color = colors.darkBlue3 }) =>
    rotate ? colors.darkBlue1 : color};
`
